
























import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";
import { IShopProviderData } from "@/models/providers/basket/shop";

@Component
export default class BasketButton extends Mixins(Context) {
  // Inject - Basket provider

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  // Inject - Shop provider

  @Inject({ from: "shopProviderData" })
  public readonly $shopProviderData!: () => IShopProviderData;

  // Computed

  public get basket() {
    return this.$basketData().basket;
  }

  public get basketId() {
    return this.$basketData().basketId;
  }
}
